import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import type { Role } from '../api/types';
import { LoadingScreen } from '../components/LoadingScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: Role[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { user, isLoading, mustChangePassword } = useAuth();
  const { pathname, search } = useLocation();

  if (isLoading) return <LoadingScreen />;
  if (!user) {
    const redirectUrl = encodeURIComponent(pathname + search);
    return <Navigate to={`/login?redirect=${redirectUrl}`} replace />;
  }
  // R0.4: force change-password before any other app route
  if (mustChangePassword && pathname !== '/app/change-password') {
    return <Navigate to="/app/change-password" replace />;
  }
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
